<template>
    <div>
        <div :style="{bottom:displayInputBottom}">
            <input class="message-input" v-model="text" :disabled="!isTimReady" :placeholder="isTimReady?'我想问主播...':'初始化中，请稍等'" placeholder-style="color:#fff;font-size:0.6rem" type="text" @keyup.enter="confirm"
         />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    isTimReady: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: '',
      displayInputBottom: '0px'
    }
  },
  methods: {
    confirm () {
      this.$emit('send-message', this.text)
      this.text = ''
    }
  },
  computed: {}
}
</script>
<style type="scss" scoped>
    .message-input {
        height: 1.35rem;
        width: 4.7671875rem;
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        padding-left: 0.421875rem;
        padding-right: 0.421875rem;
        line-height: 1.35rem;
        border: 0;
        outline: none;
        font-size: 0.6rem;
        color: #fff;
        background: none;
    }
</style>
